var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataStore = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.352 13.828c.399 0 .721-.336.721-.75 0-.415-.322-.75-.72-.75-.4 0-.722.335-.722.75 0 .414.323.75.721.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.9 11.827c0-.922.738-1.668 1.648-1.668h6.903c.91 0 1.649.746 1.649 1.668v2.502c0 .921-.738 1.668-1.649 1.668H8.549c-.91 0-1.648-.747-1.648-1.668zm1.7-.5h6.8c.313 0 .567.26.567.583v2.335a.575.575 0 0 1-.567.584H8.6a.575.575 0 0 1-.567-.584V11.91c0-.322.254-.584.567-.584Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.925 7.236C4.065 7.59 3.5 8.449 3.5 9.404v7.76c0 1.29 1.015 2.336 2.267 2.336h12.466c1.252 0 2.267-1.046 2.267-2.335v-7.76c0-.956-.564-1.814-1.425-2.17l-6.233-2.568a2.2 2.2 0 0 0-1.684 0zm14.215 9.929v-7.76a.93.93 0 0 0-.57-.868l-6.233-2.569a.88.88 0 0 0-.674 0L5.43 8.537a.93.93 0 0 0-.57.867v7.76c0 .516.406.935.907.935h12.466c.501 0 .907-.419.907-.934",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataStore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/data-store.a1293c8b.svg";